import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { IGameData } from '../../../redux/types';
import global from '../../../global';

type Props = {
  gameData: IGameData;
  onRestart: () => void;
  onNewGame: () => void;
};

export default function WinModal({ gameData, onRestart, onNewGame }: Props) {
  const { cardsAtHome } = gameData;
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (cardsAtHome < 52) return;

    global.sounds.win();

    global.playWinAnimation().then(() => {
      setOpen(true);
    });
  }, [cardsAtHome]);

  const handleRestart = () => {
    setOpen(false);
    onRestart();
  };

  const handleNewGame = () => {
    setOpen(false);
    onNewGame();
  };

  return (
    <Dialog
      open={open}
      fullWidth
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Поздравляем!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">Пасьянс успешно сошелся!</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRestart} color="default">
          Разложить еще раз
        </Button>
        <Button onClick={handleNewGame} color="primary">
          Новая игра
        </Button>
      </DialogActions>
    </Dialog>
  );
}
